// Modal overlay and container
export const modalOverlay = 'fixed inset-0 bg-black/80 z-[60] flex items-center justify-center p-4';
export const modalContainer =
  'bg-gray-900 rounded-lg w-full max-w-6xl h-[90vh] flex flex-col shadow-2xl';

// Header styles
export const headerContainer = 'flex items-center justify-between p-4 border-b border-gray-700';
export const headerTitle = 'text-lg font-semibold text-white';
export const closeButton =
  'text-gray-400 hover:text-white transition-colors rounded-lg p-1 hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed';

// Info bar styles
export const infoBarContainer =
  'flex items-center justify-center gap-6 p-2 bg-gray-800 text-sm text-gray-300';
export const infoDimensions = 'font-mono';

// Aspect ratio controls
export const aspectControlsContainer =
  'flex items-center justify-center gap-2 p-3 bg-gray-800 border-b border-gray-700';
export const aspectLabel = 'text-sm text-gray-400 mr-2';
export const aspectButtonGroup = 'inline-flex rounded-md shadow-sm';
export const aspectButton = (isActive: boolean): string =>
  `
  px-3 py-1.5 text-sm font-medium transition-all
  ${isActive ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}
  first:rounded-l-md last:rounded-r-md
  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900
`.trim();

// Content area
export const contentContainer = 'relative flex overflow-hidden flex-1';
export const imageContainer =
  'flex-1 flex items-center justify-center bg-gray-800 overflow-hidden min-h-0';
export const cropImage = 'max-w-full max-h-full object-contain';
export const reactCropWrapper = 'max-w-full max-h-full block';
export const loadingContainer = 'flex flex-col items-center justify-center gap-4 text-gray-400';

// Preview panel
export const previewPanel = 'w-80 p-4 bg-gray-800 border-l border-gray-700 flex flex-col';
export const previewHeader = 'text-sm font-medium text-gray-300 mb-3';
export const previewImageContainer =
  'flex-1 flex items-center justify-center bg-gray-900 rounded-lg overflow-hidden';
export const previewImage = 'max-w-full max-h-full object-contain';
export const previewPlaceholder = 'text-sm text-gray-500';

// Footer controls
export const footerContainer = 'flex items-center justify-end gap-3 p-4 border-t border-gray-700';
export const button = (variant: 'primary' | 'secondary', disabled: boolean = false): string => {
  const base =
    'inline-flex items-center px-4 py-2 text-sm font-medium rounded-md transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900';

  if (variant === 'primary') {
    return `${base} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 ${
      disabled ? 'opacity-50 cursor-not-allowed hover:bg-blue-600' : ''
    }`;
  }

  return `${base} bg-gray-700 text-gray-300 hover:bg-gray-600 focus:ring-gray-500 ${
    disabled ? 'opacity-50 cursor-not-allowed hover:bg-gray-700' : ''
  }`;
};
